import React, { useMemo } from "react";

const BASE_URL = "https://marchedeluxe.ch/images/";
const PLACEHOLDER = `${BASE_URL}placeholder.png`;

/**
 * ============================================================
 * GUIDE — normalisation du chemin image
 * ============================================================
 *
 * Accepte :
 * - imageUrl déjà prêt
 * - image
 * - image_url
 * - _raw.image
 * - _raw.image_url
 * - URL absolue
 * - "images/nomfichier.webp"
 * - "nomfichier.webp"
 */
const normalizeImageValue = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";

  if (/^https?:\/\//i.test(raw)) return raw;

  return raw.replace(/^images\//i, "").trim();
};

/**
 * ============================================================
 * GUIDE — construction URL finale
 * ============================================================
 */
export const getProductImageUrl = (product, cacheKey) => {
  if (!product) return PLACEHOLDER;

  const previewUrl = product?.imagePreviewUrl || "";
  if (previewUrl) return previewUrl;

  const explicitUrl = product?.imageUrl || "";
  if (explicitUrl) return explicitUrl;

  const imageValue =
    product?.image ||
    product?.image_url ||
    product?._raw?.image ||
    product?._raw?.image_url ||
    "";

  const cleanValue = normalizeImageValue(imageValue);
  if (!cleanValue) return PLACEHOLDER;

  let finalUrl = cleanValue.startsWith("http")
    ? cleanValue
    : `${BASE_URL}${cleanValue}`;

  if (cacheKey) {
    finalUrl += `?v=${encodeURIComponent(String(cacheKey))}`;
  }

  return finalUrl;
};

const ProductImage = ({ product, className, style, cacheKey }) => {
  const finalUrl = useMemo(
    () => getProductImageUrl(product, cacheKey),
    [product, cacheKey]
  );

  return (
    <img
      src={finalUrl}
      alt={product?.name || "Produit"}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        display: "block",
        visibility: "visible",
        opacity: 1,
        ...style,
      }}
      referrerPolicy="no-referrer"
      loading="lazy"
      decoding="async"
      onError={(e) => {
        const src = String(e?.currentTarget?.src || "");
        if (!src.includes("placeholder.png")) {
          e.currentTarget.src = PLACEHOLDER;
        }
      }}
    />
  );
};

export default ProductImage;
